<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    [nzOkText]="null"
    [nzTitle]="title"
    (nzOnCancel)="close()"
    nzClassName="view-modal"
>
    <ng-container *nzModalContent>
        <div nz-row *ngFor="let item of fields" class="row">
            <div nz-col class="label" [nzSpan]="labelSpan">
                {{ item.label }}:
            </div>
            <div nz-col class="value" [nzSpan]="24 - labelSpan">
                {{ data[item.key] || '' }}
            </div>
        </div>
    </ng-container>
</nz-modal>
